export type GroupKind = "product" | "service" | "package";

type GroupedItem = {
  type?: "PRODUTO" | "SERVICO" | "PACOTE" | string | null;
  product_subtype_id?: string | null;
  service_group_id?: string | null;
  package_subtype_id?: string | null;
};

export function kindOfItemType(type: GroupedItem["type"]): GroupKind | null {
  if (type === "PRODUTO") return "product";
  if (type === "SERVICO") return "service";
  if (type === "PACOTE") return "package";
  return null;
}

/** The commission group of an item is the one that matches its type. */
export function itemGroupId(item: GroupedItem): string | null {
  const kind = kindOfItemType(item.type);
  if (kind === "product") return item.product_subtype_id ?? null;
  if (kind === "service") return item.service_group_id ?? null;
  if (kind === "package") return item.package_subtype_id ?? null;
  return null;
}

/** Any product, service or package can earn commission (by its group or by its own rate). */
export function itemCanEarnCommission(item: GroupedItem): boolean {
  return kindOfItemType(item.type) !== null;
}

export function groupKey(kind: GroupKind, id: string): string {
  return `${kind}:${id}`;
}
